module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.quoteSingle) + "\n        "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.globalModalParams.type == 'customer') ? _c('p', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Add additional Customer contact email address/es here that will be used only for this quote. You can add multiple email addresses by separating each one with a comma eg. - person1@customer.com,person2@customer.com")]) : _c('p', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Add additional Vendor contact email address/es here that will be used only for this quote. You can add multiple email addresses by separating each one with a comma eg. - person1@vendor.com,person2@vendor.com")]), _vm._v(" "), (_vm.globalModalParams.type == 'customer') ? _c('v-text-field', {
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }) : _c('v-text-field', {
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdate.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}